export default __webpack_public_path__ + "static/media/coq-2.5513889e.jpg";